const React = require('react');
const { StoreProvider } = require('./src/context/StoreContext');

exports.wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
);

exports.onClientEntry = () => {
  if (document.getElementById('hubspot-script')) return;

  const script = document.createElement('script');

  script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
  script.async = true;
  script.id = 'hubspot-script';

  document.body.appendChild(script);
};
